import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'tabs/add',
      tab: {
        type: 'Settings',
        id: 'Settings',
        name: 'Settings',
        viewPath: '/App/Account/Content/Settings/Content/Schedules',
        data: {},
      },
    })
  }
}
